import React, { useEffect } from "react";
import "./Login.css";
import logo from "../../Assets/pngwing.com (3).png"
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
function Login(props) {

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


const loginUser=async(data)=>{
    try{
      const url=`https://policydekhoo-backend.onrender.com/userAuthentication`
      let response=await fetch(url,{
        method:"POST",
        headers:{"Content-Type":"application/JSON"},
        body:JSON.stringify(data)
      })
      .then(response=>response.json());
      if(response.msg!=="Incorrect Password"&&response.msg!=="Records Not found")
        {
          props.handleLoginset();
          handleClick()
          setcheck(true)
          storeData(response.element)
          console.log(response);
          setTimeout(() => {
            navigate("./ListOfService")
          }, 1000);
        }
        else{
          handleClick()
          setcheck(false)
          console.log("Invalid credentials");
        }
    }
    catch(error){
      console.log(error);
    }
}

const[uname,setuname]=useState("")
  const [password, setPassword] = useState("");
  const [role, setrole] = useState();
  // useEffect(()=>{
  //   if(uname=="admin"){
  //     setrole("admin")
  //   }
  //   else{
  //     setrole("employee")
  //   }
  // },[uname])
  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

const storeData=(response)=>{
  setrole(response.Roles)
  localStorage.setItem("userData",JSON.stringify(response))
}
// const admin={
//   uname:"admin",
//   pass:"admin@123",
//   role:"admin"

// }
// const employee={
//   uname:"jai123",
//   pass:"123",
//   role:"employee"
// }

const handleSubmit=(e)=>{
  e.preventDefault();
  
  
  if((uname!==""&&password!==""))
  {
    const data={
      username:uname,
      password:password
    }
    // console.log(data);
    // localStorage.setItem("role",role)
    // localStorage.setItem("uname",uname)
    // localStorage.setItem("password",password)
    loginUser(data)
   

}
else{
  handleClick()
}

}





const [state, setState] = React.useState({
  open: false,
  vertical: 'bottom',
  horizontal: 'right',
});


const { vertical, horizontal, open } = state;
const [check,setcheck]=useState(false)



const handleClick = () => {
  setState({ ...state, open: true });
};

const handleClose = () => {
  setState({ ...state, open: false });
};





const action = (
  <React.Fragment>
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </React.Fragment>
);














  return (
    <div id="main-div">

      <form onSubmit={handleSubmit}>
        <div className=" mx-auto row center justify-content-center ">
      <div className="row my-5">
        <div className="col text-center justify-content-center">
        <img src={logo} alt="" className="wid-responsive" />
        </div>
      </div>
          <div className="col-lg-4 col-md-7 col-sm-8 col-10 from text-center py-4">
            <h1>Login</h1>
            <div className="row my-5 justify-content-center">
              <div className="px-sm-5 px-3">
                <TextField
                  fullWidth
                  id="standard-search"
                  label="Username"
                  type="text"
                  required
                  value={uname}
                  onChange={(e)=>{setuname(e.target.value)}}
                  variant="standard"
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="px-sm-5 px-3" >
                <FormControl fullWidth variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                  <Input
                    id="standard-adornment-password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    required
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col text-center my-4">
                <button style={{ background: "#003E74" }} className="btn text-white rounded-5 px-sm-5 px-4">
                  Login
                </button>
              </div>
            </div>

            <div className="row mb-4 px-sm-5 px-2" style={{whiteSpace:"nowrap"}}>
            <div className="col-6">
              <div className="text-start">
                <input type="checkbox" name="" id="" className="mx-1 rounded-5" />
                <label htmlFor="check"className="font-size"style={{color:"grey"}}>Remember Me</label>
              </div>
            </div>

            <div className="col-6 text-end">
              
                <span className="font-size">
                  <label style={{color:"grey"}}>Forgot </label> <label className="text-primary"> Username/Password</label>
                </span>
              
            </div>
          </div>
          </div> 
        </div>
      </form>
      {/* <div className="row fixed-bottom">
        <div className="col text-center font-size">
            <span >
              © 2020 Policy Dekhoo | Powered by Policy Dekhoo
            </span>
        </div>
      </div> */}
      
      <Box sx={{ width: 500 }}>
      
      <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      key={vertical + horizontal}
      action={action}
        open={state.open}
        autoHideDuration={5000}
        TransitionComponent={SlideTransition}
        onClose={handleClose}
        message={check==true?"Login Successfully":"Invalid Credentials"}
      />
    </Box>
    </div>
  );
}

export default Login;
